import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCapricorn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.66663 10.9222V10.6666C4.66663 8.82564 6.15901 7.33325 7.99996 7.33325C9.84091 7.33325 11.3333 8.82564 11.3333 10.6666V24.6666V13.3333C11.3333 10.0195 14.0196 7.33325 17.3333 7.33325C20.647 7.33325 23.3333 10.0195 23.3333 13.3333V24.6666M23.3333 24.6666C23.3333 26.8757 25.1242 28.6666 27.3333 28.6666C29.5424 28.6666 31.3333 26.8757 31.3333 24.6666C31.3333 22.4574 29.5424 20.6666 27.3333 20.6666C25.1242 20.6666 23.3333 22.4574 23.3333 24.6666ZM23.3333 24.6666C23.3333 27.6121 20.9455 29.9999 18 29.9999",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCapricorn;
